import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal, Button } from 'components';
import { IModalAction } from 'models/modal';
import { showModal, closeModal } from 'modules/modal';
const { connect } = require('react-redux');
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { createCategoryMenuItem } from 'redux/modules/menueditor';
import { getCategoryDomainValues } from 'redux/modules/domainvalues';
import { ICategoryDomainValue } from 'models/common';
import { IStore } from 'redux/IStore';
import { PortalSelectMenu } from 'components/FormControls';
import { IMenuEditorAction } from 'models/menueditor/menueditor';
import { MenuItemType } from 'models/enums/menuitemtype';
require('./style.css');

interface IProps {
	showHeaderCloseButton: boolean;
	categoryDomainValues?: ICategoryDomainValue[];
	menuItemType: MenuItemType;

	/* func props */
	getCategoryDomainValues?: () => void;
	createCategoryMenuItem?: (categoryKey: number, menuItemType: MenuItemType) => IMenuEditorAction;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	firstDropdownCategoryKey: number;
	secondDropdownCategoryKey: number;
	thirdDropdownCategoryKey: number;
	fourthDropdownCategoryKey: number;
}

@connect(
	(state: IStore) => ({
		categoryDomainValues: state.domainValues.categories,
	}),
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
		createCategoryMenuItem: (categoryKey: number, menuItemType: MenuItemType) =>
			dispatch(createCategoryMenuItem(categoryKey, menuItemType)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MenuTypeCategory extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			firstDropdownCategoryKey: null,
			secondDropdownCategoryKey: null,
			thirdDropdownCategoryKey: null,
			fourthDropdownCategoryKey: null,
		};

		this.onFirstCategoryDropdownChange = this.onFirstCategoryDropdownChange.bind(this);
		this.onSecondCategoryDropdownChange = this.onSecondCategoryDropdownChange.bind(this);
		this.onThirdCategoryDropdownChange = this.onThirdCategoryDropdownChange.bind(this);
		this.onFourthCategoryDropdownChange = this.onFourthCategoryDropdownChange.bind(this);
		this.handleSaveAndCloseButtonClick = this.handleSaveAndCloseButtonClick.bind(this);
	}

	public componentDidMount() {
		this.props.getCategoryDomainValues();
	}

	public onFirstCategoryDropdownChange(key: number) {
		this.setState({
			firstDropdownCategoryKey: key,
			secondDropdownCategoryKey: null,
			thirdDropdownCategoryKey: null,
			fourthDropdownCategoryKey: null,
		});
	}

	public onSecondCategoryDropdownChange(key: number) {
		this.setState({
			secondDropdownCategoryKey: key,
			thirdDropdownCategoryKey: null,
			fourthDropdownCategoryKey: null,
		});
	}

	public onThirdCategoryDropdownChange(key: any) {
		this.setState({
			thirdDropdownCategoryKey: key,
			fourthDropdownCategoryKey: null,
		});
	}

	public onFourthCategoryDropdownChange(key: any) {
		this.setState({
			fourthDropdownCategoryKey: key,
		});
	}

	private handleSaveAndCloseButtonClick() {
		let categoryKey: number = null;

		if (this.state.fourthDropdownCategoryKey) {
			categoryKey = this.state.fourthDropdownCategoryKey;
		} else if (this.state.thirdDropdownCategoryKey) {
			categoryKey = this.state.thirdDropdownCategoryKey;
		} else if (this.state.secondDropdownCategoryKey) {
			categoryKey = this.state.secondDropdownCategoryKey;
		} else if (this.state.firstDropdownCategoryKey) {
			categoryKey = this.state.firstDropdownCategoryKey;
		}

		if (categoryKey) {
			this.props.createCategoryMenuItem(categoryKey, this.props.menuItemType);
		}
	}

	public render() {
		const { showHeaderCloseButton, closeModal, t, categoryDomainValues } = this.props;

		let firstDropdownCategories = [];
		let secondDropdownCategories = [];
		let thirdDropdownCategories = [];
		let fourthDropdownCategories = [];
		if (categoryDomainValues) {
			firstDropdownCategories = categoryDomainValues
				.filter((x) => !x.parentKey)
				.map((category: ICategoryDomainValue) => {
					return {
						key: category.key,
						value: t(`DV_Categories_${category.key}`),
					};
				});

			if (this.state.firstDropdownCategoryKey) {
				secondDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === this.state.firstDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}

			if (this.state.secondDropdownCategoryKey) {
				thirdDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === this.state.secondDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}

			if (this.state.thirdDropdownCategoryKey) {
				fourthDropdownCategories = categoryDomainValues
					.filter((x) => x.parentKey === this.state.thirdDropdownCategoryKey)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}
		}

		return (
			<Modal
				title={'Select category'}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="menuItemTypeCategory"
			>
				<PortalPageSection usage="admin">
					<div className="row">
						<div className="col-md-12">
							<PortalSelectMenu
								usage="admin"
								input={{
									id: 'firstCategoryDropdown',
									onChange: this.onFirstCategoryDropdownChange,
									value: this.state.firstDropdownCategoryKey,
									name: 'firstCategoryDropdown',
								}}
								items={firstDropdownCategories}
							/>
						</div>
					</div>

					{this.state.firstDropdownCategoryKey && secondDropdownCategories.length > 0 ? (
						<div className="row">
							<div className="col-md-12">
								<PortalSelectMenu
									usage="admin"
									input={{
										id: 'secondCategoryDropdown',
										onChange: this.onSecondCategoryDropdownChange,
										value: this.state.secondDropdownCategoryKey,
										name: 'secondCategoryDropdown',
									}}
									items={secondDropdownCategories}
								/>
							</div>
						</div>
					) : null}
					{this.state.secondDropdownCategoryKey && thirdDropdownCategories.length > 0 ? (
						<div className="row">
							<div className="col-md-12">
								<PortalSelectMenu
									usage="admin"
									input={{
										id: 'thirdCategoryDropdown',
										onChange: this.onThirdCategoryDropdownChange,
										value: this.state.thirdDropdownCategoryKey,
										name: 'thirdCategoryDropdown',
									}}
									items={thirdDropdownCategories}
								/>
							</div>
						</div>
					) : null}
					{this.state.thirdDropdownCategoryKey && fourthDropdownCategories.length > 0 ? (
						<div className="row">
							<div className="col-md-12">
								<PortalSelectMenu
									usage="admin"
									input={{
										id: 'fourthCategoryDropdown',
										onChange: this.onFourthCategoryDropdownChange,
										value: this.state.fourthDropdownCategoryKey,
										name: 'fourthCategoryDropdown',
									}}
									items={fourthDropdownCategories}
								/>
							</div>
						</div>
					) : null}
				</PortalPageSection>
				<ButtonsSection>
					<div className="row">
						<div className="col-sm-12">
							<Button type="button" usage="admin" onClick={this.handleSaveAndCloseButtonClick}>
								{t('BSPortal_Common_SaveAndClose')}
							</Button>
						</div>
					</div>
				</ButtonsSection>
			</Modal>
		);
	}
}

export { MenuTypeCategory };
